import {
  WIRCreatedSectionKey,
  WIRCreatedSections,
  WIRCreateJourneyStepsKeys,
} from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR } from 'types/wellGuardian';

import { getWirCreatedSectionKey } from './getSectionData';

export const getWirCreatedSections = (wir: WIR | null, country: string) => {
  if (country === CountryData.congo) {
    return (
      (wir &&
        Object.keys(WIRCreatedSections)
          .map(item => ({
            label: WIRCreatedSections[item as WIRCreatedSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.CG_WIR_CREATED,
          }))
          .filter(stepItem => stepItem.label !== WIRCreatedSections.organiseKickOffMeeting)) ??
      []
    );
  } else {
    return (
      (wir &&
        Object.keys(WIRCreatedSections).map(item => ({
          label: WIRCreatedSections[item as WIRCreatedSectionKey],
          value: item,
          phase: getWirCreatedSectionKey(country),
        }))) ??
      []
    );
  }
};
